/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_Search_ReplaceInputs */

const en_quicktools_tab_search_replace = /** @type {(inputs: Quicktools_Tab_Search_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search & Replace`)
};

const fr_quicktools_tab_search_replace = /** @type {(inputs: Quicktools_Tab_Search_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher et remplacer`)
};

const de_quicktools_tab_search_replace = /** @type {(inputs: Quicktools_Tab_Search_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchen und Ersetzen`)
};

const it_quicktools_tab_search_replace = /** @type {(inputs: Quicktools_Tab_Search_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca e sostituisci`)
};

const ru_quicktools_tab_search_replace = /** @type {(inputs: Quicktools_Tab_Search_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск и замена`)
};

const es_quicktools_tab_search_replace = /** @type {(inputs: Quicktools_Tab_Search_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar y reemplazar`)
};

const zh_cn2_quicktools_tab_search_replace = /** @type {(inputs: Quicktools_Tab_Search_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索和替换`)
};

const ja_quicktools_tab_search_replace = /** @type {(inputs: Quicktools_Tab_Search_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索と置換`)
};

const hi_quicktools_tab_search_replace = /** @type {(inputs: Quicktools_Tab_Search_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोजें और बदलें`)
};

const pt_pt2_quicktools_tab_search_replace = /** @type {(inputs: Quicktools_Tab_Search_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Localizar e substituir`)
};

/**
* | output |
* | --- |
* | "Search & Replace" |
*
* @param {Quicktools_Tab_Search_ReplaceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_search_replace = /** @type {((inputs?: Quicktools_Tab_Search_ReplaceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_Search_ReplaceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_quicktools_tab_search_replace(inputs)
	if (locale === "de") return de_quicktools_tab_search_replace(inputs)
	if (locale === "it") return it_quicktools_tab_search_replace(inputs)
	if (locale === "ru") return ru_quicktools_tab_search_replace(inputs)
	if (locale === "es") return es_quicktools_tab_search_replace(inputs)
	if (locale === "zh-CN") return zh_cn2_quicktools_tab_search_replace(inputs)
	if (locale === "ja") return ja_quicktools_tab_search_replace(inputs)
	if (locale === "hi") return hi_quicktools_tab_search_replace(inputs)
	if (locale === "pt-PT") return pt_pt2_quicktools_tab_search_replace(inputs)
	return en_quicktools_tab_search_replace(inputs)
});